import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Início", to: "/" },
  { label: "Imóvel", to: "/imovel" },
  { label: "Veículo", to: "/veiculo" },
  { label: "Todos", to: "/todos" },
];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b border-slate-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-5 h-[84px] flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 group"
          aria-label="Bellani Consórcios"
        >
          <img
            src="/bellani-logo-v3.png"
            alt="Bellani Consórcios"
            className="h-14 md:h-16 w-auto object-contain group-hover:scale-105 transition-transform"
          />
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => {
            const active = location.pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                className={`text-sm font-semibold transition-colors relative py-1 ${
                  active ? "text-[#1976D2]" : "text-slate-500 hover:text-[#1976D2]"
                }`}
              >
                {n.label}
                {active && (
                  <span className="absolute -bottom-1 left-0 h-[3px] w-full rounded-full bg-[#C9A227]" />
                )}
              </Link>
            );
          })}
        </nav>

        {/* Mobile toggle */}
        <button className="md:hidden text-slate-600" onClick={() => setOpen((o) => !o)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white px-5 py-3 flex flex-col gap-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className={`py-2 text-sm font-semibold ${
                location.pathname === n.to ? "text-[#1976D2]" : "text-slate-600"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
